import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const CardChart = ({ icon, title, children, bgColor, px = 2, py = 2, border = '#e5e7eb' }) => {
  return (
    <Box sx={{ border: `1px solid ${border}`, borderRadius: 3, overflow: 'hidden', bgcolor: bgColor }}>
      <Box
        sx={{
          px: 3,
          pt: 2,
          bgcolor: bgColor
        }}
        className='items-center flex gap-2 sticky top-0 z-2'
      >
        {icon && <FontAwesomeIcon size='xl' icon={icon} />}
        <Typography
          className='opacity-75'
          component={'span'}
          sx={{
            fontWeight: 800,
            fontSize: 18
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box sx={{ px, py }}>{children}</Box>
    </Box>
  )
}

export default CardChart
